const store = {
  namespaced: true,
  state: {
    categoryList: []
  },
  getters: {},
  mutations: {},
  actions: {
    async createCategory({ rootState }, params = {}) {
      const data = await rootState.http("/parts/category/createPartsCategory", params);
      return data;
    },
    async getCategoryList({ rootState }, params = {}) {
      const data = await rootState.http("/parts/category/queryPartsCategoryList", params);
      return data;
    },
    async deleteCategory({ rootState }, params = {}) {
      const data = await rootState.http("/parts/category/deletePartsCategory", params);
      return data;
    },
    async updateCategory({ rootState }, params = {}) {
      const data = await rootState.http("/parts/category/updatePartsCategory", params);
      return data;
    },
    async getCategoryListFillAll({ rootState }, params = {}) {
      const data = await rootState.http("/parts/category/queryPartsCategoryFillingList", params);
      return data;
    }
  }
};

export default store;
